// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ae270511","879":"46cf0e8e"}[chunkId] + ".chunk.js";
};